module.exports = __webpack_public_path__ + "img/skyward-spine.31b14453.webp";